module.exports = __webpack_public_path__ + "static/media/email-confirmation-icon.1d8d85aa.svg";